<template>
  <div>
    <div :class="roomType">
      <h5 :class="`${roomType}-roomsLabel`">
        <span v-for="i in nbTravellers" :class="`${roomType}-roomsLabel__icon`">
          <i class="far fa-user"></i>
        </span>

        <span :class="`${roomType}-roomsLabel__str`">
          {{ label }}
        </span>

        <span v-if="description">
          ({{ description |lowercase }})
        </span>
      </h5>
    </div>

    <div :class="searchFormClass">
      <div v-for="n in nbTravellers" class="travellers-input">
        <search :rank="n" :required="true"
                :placeholder="$t('_select_traveller', {nb : nbTravellers > 1 ? n : null})"
                :already-displayed-travellers="alreadySelectedTravellers"
                :index="roomType + '-' + index + '-' + n"
                :is-unlogged="isUnlogged" :unlogged-infos="unloggedInfos"
                @change="onChangeTraveller"
                :value="getTraveller(roomType, index, n)"
        />
      </div>

      <div class="bed-type-select" v-if="manageBedType && isDouble">
        <multiselect v-model="selectedBedType"
                     :options="bedTypeOptions"
                     :searchable="false"
                     track-by="value"
                     select-label=""
                     deselect-label=""
                     selected-label=""
        >
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span class="option__title">
                {{ props.option.label }}
              </span>
            </div>
          </template>

          <template slot="singleLabel" slot-scope="props">
            {{ props.option.label }}
          </template>
        </multiselect>
      </div>
  </div>
  </div>
</template>

<script>
import search from '@/components/frontoffice/form/traveller/search'

export default {
  name: 'travellers-form',

  components: {
    search
  },

  props: {
    roomType: {
      type: String,
      required: true,
      validator(value) {
        return ['single', 'double'].indexOf(value) !== -1
      }
    },
    alreadySelectedTravellers: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    isUnlogged: {
      type: Boolean,
      default: false
    },
    unloggedInfos: Object,
    manageBedType: {
      type: Boolean,
      default: false
    },
    bedType: String,
    description: String,
    allocation: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      defaultBedType: 'adult-double',
      bedTypeOptions: [
        { value: 'adult-single', label: this.$t('offline.bedType.adult-single') },
        { value: 'adult-double', label: this.$t('offline.bedType.adult-double') }
      ],
      selectedBedType: null
    }
  },

  created () {
    this.initBedTypes()
  },

  methods: {
    initBedTypes () {
      if (this.isDouble) {
        if (this.bedType) this.defaultBedType = this.bedType

        this.bedTypeOptions.map(opt => {
          if (opt.value === this.defaultBedType) this.selectedBedType = opt
        })
      }
    },

    onChangeTraveller (value) {
      this.$emit('traveller', {
        roomType: this.roomType,
        index: this.index,
        value: value
      })
    },

    onChangeBedType (value) {
      this.$emit('bedType', {
        roomType: this.roomType,
        index: this.index,
        value: value
      })
    },

    getTraveller (roomType, roomIndex, travellerIndex) {
      if (this.allocation) {
        return this.allocation[roomType].travellers[roomIndex -1][travellerIndex]
      }
    }
  },

  computed: {
    isSingle () {
      return this.roomType === 'single'
    },

    isDouble () {
      return this.roomType === 'double'
    },

    label () {
      return this.$t(`booking.room.${this.roomType}`)
    },

    nbTravellers () {
      return this.isSingle ? 1 : 2
    },

    searchFormClass () {
      return this.isSingle ? 'single-form' : 'double-form'
    }
  },

  watch: {
    selectedBedType (value) {
      this.onChangeBedType(value ? value.value : null)
    }
  }
}
</script>
